import { render } from "./internal-notes.vue?vue&type=template&id=32b51468&ts=true"
import script from "./internal-notes.ts?vue&type=script&lang=ts&external"
export * from "./internal-notes.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__